import { render, staticRenderFns } from "./TipoHora.vue?vue&type=template&id=f1a73f32&scoped=true"
import script from "./TipoHora.vue?vue&type=script&lang=js"
export * from "./TipoHora.vue?vue&type=script&lang=js"
import style0 from "./TipoHora.vue?vue&type=style&index=0&id=f1a73f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a73f32",
  null
  
)

export default component.exports